import type {EnvironmentSubmit} from '../use-environment-selection'
import type {EnvironmentOption} from './environment-option'
import type {PreparedPrompt} from '@github-ui/ahp-session-client/contracts'
import type {McpPermissionMode} from '@github-ui/agent-sessions-types/mcp-permission-mode'
import type {AgentMode} from '@github-ui/copilot-shared-ui/utils/agent-mode'

interface DispatchEnvironmentSubmissionInput {
  selectedEnvironment: EnvironmentOption | null
  onEnvironmentSubmit?: EnvironmentSubmit
  prompt: PreparedPrompt
  agentMode?: AgentMode
  repositoryNwo?: string
  baseRef?: string
  mcpPermissionMode?: McpPermissionMode
  failureOwner?: 'caller'
  scopeLogin?: string
  space?: {owner: string; slug: string}
}

export async function dispatchEnvironmentSubmission({
  selectedEnvironment,
  onEnvironmentSubmit,
  prompt,
  agentMode,
  repositoryNwo,
  baseRef,
  mcpPermissionMode,
  failureOwner,
  scopeLogin,
  space,
}: DispatchEnvironmentSubmissionInput): Promise<boolean> {
  const isRelayBacked = selectedEnvironment?.kind === 'ahp' || selectedEnvironment?.kind === 'sandbox'
  if (isRelayBacked && selectedEnvironment.environmentId && onEnvironmentSubmit) {
    await onEnvironmentSubmit({
      environmentId: selectedEnvironment.environmentId,
      prompt,
      ...(agentMode ? {agentMode} : {}),
      ...(repositoryNwo ? {repositoryNwo} : {}),
      ...(baseRef ? {baseRef} : {}),
      ...(selectedEnvironment.kind === 'sandbox' ? {managedSandbox: true} : {}),
      ...(mcpPermissionMode ? {mcpPermissionMode} : {}),
      ...(failureOwner ? {failureOwner} : {}),
      ...(!repositoryNwo && !space && scopeLogin ? {scopeLogin} : {}),
      ...(!repositoryNwo && space ? {space} : {}),
    })
    return true
  }
  return false
}
